/**
 * Detecção de plataforma de execução.
 *
 * Web e nativo (Capacitor) trocam o refresh token por caminhos diferentes — cookie
 * HttpOnly no browser, corpo/header no app — então essa checagem decide qual
 * transporte a request vai pedir. Fica isolada aqui porque http.ts, session.ts e
 * tokenStore.ts precisam todos da mesma resposta.
 */

/** Nome do header que informa a plataforma ao backend. */
export const PLATFORM_HEADER = "X-Client-Platform"

/** Valor enviado em PLATFORM_HEADER quando rodando dentro do app. */
export const NATIVE_PLATFORM = "native"

/** Header usado pelo app nativo para apresentar o refresh token. */
export const REFRESH_TOKEN_HEADER = "X-Refresh-Token"

export function isNativeApp(): boolean {
  return (
    typeof window !== "undefined" &&
    (window.location.protocol === "capacitor:" ||
      window.location.protocol === "ionic:" ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).Capacitor?.isNativePlatform?.() === true)
  )
}
